import { Filter, ConditionValue } from 'app/components/filters/types';
import { SelectItem } from 'ui/common/select/types';
import { trimValue } from '../trim-value';

export const getFavouriteConditionValue = (id: number, filter: Filter, conditionValue: ConditionValue) => {
  const newConditionValue = filter.advancedField && {
    id,
    code: { v: trimValue(conditionValue) },
    myValue: false,
    periodPredef: { v: 0 },
    operator: filter.advancedField.valueOperator,
    dbFunction: filter.advancedField.dbFunctionValue
  };

  return trimValue(conditionValue) !== '' && newConditionValue;
};

export const createConditionValue = (id: number, filter: Filter, value: SelectItem[]) => {
  return value && (value instanceof Array
    && value.map(v => getFavouriteConditionValue(id++, filter, v.value)) || [getFavouriteConditionValue(id++, filter, value)]);
};
